<template>
  <div :class="['slider-menu', selectedTheme, menuState]">
    <MenuNavigation 
      v-if="isLoaded && environmentVariables.basePath.value != ''"
    />
  </div>
</template>

<script setup lang="ts">
import {onMounted, provide, ref} from 'vue';
import MenuNavigation from '@/components/MenuNavigation/MenuNavigation.vue';
import { useEnvVariables } from '@/composables/useEnvVariables';
import { useTheme } from '@/composables/useTheme';
import {useNavigationData} from "@/composables/useNavigationData";
import {AppProps, standaloneConfigType} from '@/types/menuNavigation';
import useMenuState from "@/composables/useMenuState";

const props = withDefaults(defineProps<AppProps>(), {
    isAdmin: false,
});

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits<{
    navigation: [{code: string}]
    toogleMenuState: [{code: 'collapsed' | 'extended'}]
}>();

const { getEnvironmentVariables, environmentVariables } = useEnvVariables();
const { setSelectedTheme, selectedTheme } = useTheme();
const { menuState, toggleState } = useMenuState();
const { setButtonNotification, setButtonDisplay, initializeNavigationData } = useNavigationData(props.isAdmin);

const isLoaded = ref(false);

onMounted(async () => {
  if (!props.isStandalone) {
    await getEnvironmentVariables();
    initializeNavigationData();
    selectedTheme.value = setSelectedTheme(environmentVariables.presetGraphique.value);
    setConditionalButtons();
  }
  isLoaded.value = true;
});


const emitNavigation = (code: string) => {
  if(code === 'extend'){
    toggleState();
    emit('toogleMenuState', {code: menuState.value});
    return;
  }

  emit('navigation', {code});
  setButtonNotification(code, false);
};

provide('emitNavigation', emitNavigation);
provide('appProps', props);

const { setButtonActive } = useNavigationData(props.isAdmin);

const setStandaloneConfig = async (value: standaloneConfigType) => {
  await getEnvironmentVariables(value);
  selectedTheme.value = setSelectedTheme(environmentVariables.presetGraphique.value);
  const rootEl = <HTMLElement>document.querySelector('its-navigation-menu');

  const backgroundImg = `${window.location.protocol}//${environmentVariables.hostname.value}/${environmentVariables.presetGraphiqueImg.value}`;
  rootEl.style.backgroundImage = `url('${backgroundImg}')`;
  setConditionalButtons();
}

defineExpose({setButtonNotification, setButtonDisplay, setButtonActive, toggleState, setStandaloneConfig});

const setConditionalButtons = () => {
  if(!environmentVariables.newsIntranetIsEnabled.value) {
    setButtonDisplay('actualites', false);
  }
  if(!environmentVariables.homeMailButtonIsEnabled.value) {
    setButtonDisplay('mail', false);
  }
}
</script>

<style lang="scss">
    @use '@/styles/main.scss';
    @use './App.scss';
    @use '@/components/MenuNavigation/MenuNavigation.scss';
    @use '@/components/MenuNavigationCategory/MenuNavigationCategory.scss';
    @use '@/components/MenuButton/MenuButton.scss';
</style>
